let blurBackgroundAsset: string;

export const setBlurBackgroundAsset = (value: string) => (blurBackgroundAsset = value);

export const getBlurBackgroundAsset = () => blurBackgroundAsset;
